import React, { useState } from "react";
import { multiuseBaskets } from "./data/multiuseBasketData";
import "../../App.css";
import { Helmet } from "react-helmet";
import banner from "../../assets/multiuse-basket-banner.png";

const MultiuseBasket = () => {
  const [selectedBasket, setSelectedBasket] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [activeTab, setActiveTab] = useState("desc");
const [previewImage, setPreviewImage] = useState(null);
  const getYouTubeWatchUrl = (embedUrl) => {
    if (!embedUrl) return "#";
    const videoId = embedUrl.split("/embed/")[1];
    return `https://www.youtube.com/watch?v=${videoId}`;
  };

  const filteredBaskets = multiuseBaskets.filter(
    (item) => item.category === "multiuse-basket"
  );

  if (!filteredBaskets.length) {
    return <p style={{ textAlign: "center" }}>No products found.</p>;
  }

  return (
    <div className="product-container">

      <Helmet>
       
        <title>Multi Use Kitchen Basket | Cabinet Storage Organizer</title>
      </Helmet>

      {/* BANNER */}
      <div className="hinge-banners">
        <img src={banner} alt="Multiuse Basket Banner"  loading="lazy"/>
        <h2 className="banner-text">Products</h2>
      </div>

      <h2 style={{ textAlign: "center", fontSize: "2rem", padding: "10px" }}>
        MULTIUSE BASKETS PRIME & SLIMLINE
      </h2>

      {/* ================= GRID ================= */}
      {!selectedBasket ? (

        <div className="product-grid">
          {filteredBaskets.map((item) => (
            <div
              className="product-card"
              key={item.code}
              onClick={() => {
                setSelectedBasket(item);
                setMainImage(item.mainImage || item.image);
                setActiveFAQ(null);
                setActiveTab("desc");
              }}
            >
            <img
  src={item.mainImage}
  alt={item.name}
  loading="lazy"
  onClick={(e) => {
    e.stopPropagation();
    setPreviewImage(item.mainImage);
  }}
  style={{ cursor: "zoom-in" }}
/>
              <h4>{item.name}</h4>
            </div>
          ))}
        </div>

      ) : (
        <>
          {/* BACK */}
          <button
            className="back-btn"
            onClick={() => {
              setSelectedBasket(null);
              setMainImage("");
              setActiveFAQ(null);
              setActiveTab("desc");
            }}
          >
            ← Back
          </button>

          <div className="hinge-details">

            {/* LEFT */}
            <div className="left-box">

              <div className="hinge-image">
                 <img
  src={mainImage}
  alt={selectedBasket?.name}
  className="zoomable-image"
  onClick={() => setPreviewImage(mainImage)}
  onError={() => console.log("Failed:", mainImage)}
/>
              </div>

              {selectedBasket.thumbnails?.length > 0 && (
                <div className="hinge-thumbnails">
                  {selectedBasket.thumbnails.map((img, i) => (
                    <img
  key={i}
  src={img}
  alt=""
  loading="lazy"
  onClick={() => setMainImage(img)}
  onDoubleClick={() => setPreviewImage(img)}
/>
                  ))}
                </div>
              )}

              {selectedBasket.video && (
                <div className="product-video">
                  <iframe
                    width="100%"
                    height="300"
                    src={selectedBasket.video}
                    title="Product Video"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              )}

            </div>

            {/* RIGHT */}
            <div className="hinge-info">

              <h2>{selectedBasket.name}</h2>

              {(selectedBasket.price || selectedBasket.oldPrice) && (
                <div className="price-box">
                  <span className="price">{selectedBasket.price}</span>
                  <span className="old-price">{selectedBasket.oldPrice}</span>
                </div>
              )}

              {(selectedBasket.sku || selectedBasket.stock) && (
                <div className="product-meta">
                  {selectedBasket.sku && <p><strong>SKU:</strong> {selectedBasket.sku}</p>}
                  {selectedBasket.stock && <p><strong>Status:</strong> {selectedBasket.stock}</p>}
                </div>
              )}

              {/* BUTTONS */}
              <div className="btns">

                {selectedBasket.catalogue && (
                  <a href={selectedBasket.catalogue} download>
                    📥 Download Catalogue
                  </a>
                )}

                {selectedBasket.inquiry && (
                  <a href={selectedBasket.inquiry} target="_blank" rel="noreferrer">
                    💬 Inquiry
                  </a>
                )}

                {selectedBasket.video && (
                  <a
                    href={getYouTubeWatchUrl(selectedBasket.video)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    ▶ Watch Video
                  </a>
                )}

              </div>

              {/* TABS */}
              <div className="tabs">
                <button
                  className={activeTab === "desc" ? "active" : ""}
                  onClick={() => setActiveTab("desc")}
                >
                  Description
                </button>

                <button
                  className={activeTab === "info" ? "active" : ""}
                  onClick={() => setActiveTab("info")}
                >
                  Additional Info
                </button>
              </div>

              {/* DESCRIPTION */}
              {activeTab === "desc" && (
                <>
                  <p>{selectedBasket.short}</p>
                  <ul>
                    {selectedBasket.features?.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </>
              )}

              {/* ✅ FIXED ADDITIONAL INFO */}
              {activeTab === "info" && (
                <div className="info-table">
                  {selectedBasket.specifications?.length > 0 ? (
                    <table>
                      <tbody>
                        {selectedBasket.specifications.map((s, i) => (
                          <tr key={i}>
                            <td><b>{s.label}</b></td>
                            <td>{s.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No additional info</p>
                  )}
                </div>
              )}

            </div>

          </div>

          {/* SPEC TABLE */}
          {selectedBasket.specTable?.length > 0 && (
            <div className="spec-section">
              <h2>Specifications</h2>

              <table className="spec-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Code</th>
                    <th>Size</th>
                    <th>Finish</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedBasket.specTable.map((item, i) => (
                    <tr key={i}>
                      <td>{item.item}</td>
                      <td>{item.code}</td>
                      <td>{item.size}</td>
                      <td>{item.finish}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* FAQ */}
          {selectedBasket.faq && (
            <div className="faq-section">

              <h2>Frequently Asked Questions</h2>

              {selectedBasket.faq.map((item, index) => (
                <div key={index} className="faq-box">

                  <div
                    className={`faq-question ${activeFAQ === index ? "active" : ""}`}
                    onClick={() =>
                      setActiveFAQ(activeFAQ === index ? null : index)
                    }
                  >
                    <h4>{item.question}</h4>
                    <span>{activeFAQ === index ? "-" : "+"}</span>
                  </div>

                  {activeFAQ === index && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}

                </div>
              ))}

            </div>
          )}
 {previewImage && (
      <div
        className="image-preview-modal"
        onClick={() => setPreviewImage(null)}
      >
        <span
          className="image-preview-close"
          onClick={() => setPreviewImage(null)}
        >
          ✕
        </span>

        <img
          src={previewImage}
          alt="Preview"
          className="image-preview-full"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    )}
        </>
      )}

    </div>
  );
};

export default MultiuseBasket;